import React from "react";
import { Layout} from 'antd'
import Link from "../common/Link";
import badge from "../assets/badge.jpg"
import styled from 'styled-components';

const {Footer} = Layout;

const StyledLink = styled(Link)`
  color: gray;
`

const StyledFooter = styled(Footer)`
  && {
    color: gray;
    display: flex;
    background: white;
    align-items: center;
    justify-content: space-between;
    padding: 4px 24px;
  }
`

const AppFooter: React.FC<any> = () => {
  const hostname = window.location.hostname;
  const isCosco = hostname.includes('.lines');

  if (isCosco) {
    return (<StyledFooter>
      <div style={{color:'gray'}}>COPYRIGHT©1998-2023 ALL RIGHTS RESERVED</div>
      <div>
        <StyledLink href={'https://lines.coscoshipping.com/home/item?language=en-US'}>Terms of Use</StyledLink> |&nbsp;
        <StyledLink href={'https://beian.miit.gov.cn/'}>沪ICP备13003917号-1</StyledLink> |&nbsp;
        <StyledLink href={'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31022102000157'}>沪公网安备31022102000157号</StyledLink> |&nbsp;
        <StyledLink href={'https://beian.miit.gov.cn/'}>沪ICP备16018315号-1</StyledLink>| &nbsp;
        <StyledLink href={'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31022102000135'}>沪公网安备 31022102000135号</StyledLink>| &nbsp;
        <StyledLink href={'http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020200709093534000006070085-SAIC_SHOW_310000-20200928105913857526&signData=MEUCIQDqAvUJpVMTTb+nqhKQxGRVZlqZg5/gRZ57cbs+OVvVhgIgIeTr6k4xGvFV2bJ75eDF97xgk05XZPH6k4/DfyT1H8Q='}>
          <img alt={'上海工商'} src={badge} style={{width:'15px', height:'15px'} }/>上海工商
        </StyledLink>
      </div>
    </StyledFooter>);
  }

  return <StyledFooter>
    <div style={{color:'gray'}}><StyledLink href={'https://www.oocl.com/eng/copyright'}>Copyright © 1998-2023.</StyledLink> Orient Overseas Container Line Limited. All rights reserved.&nbsp;
      <StyledLink href={'https://beian.miit.gov.cn/'}>粤ICP备11094507号</StyledLink> <br/>
      <StyledLink href={'https://www.oocl.com/eng/termsofuse'}>Terms of Use</StyledLink> |&nbsp;
      <StyledLink href={'https://www.oocl.com/eng/privacyandsecurity'}>Privacy & Security</StyledLink> |&nbsp;
      <StyledLink href={'https://www.oocl.com/eng/onlinesecurity'}>Online Security</StyledLink> |&nbsp;
      <StyledLink href={'https://www.oocl.com/eng/customercommunicationspolicy'}>Customer Communications Policy</StyledLink> |&nbsp;
      <StyledLink href={'https://osm.digital.oocl.com/cookiePolicy'}>Cookie Policy</StyledLink>
    </div>
  </StyledFooter>
}

export default AppFooter;